// extracted by mini-css-extract-plugin
module.exports = {"LandingCont":"Landing_LandingCont__2ygUI","Text":"Landing_Text__1ehgH","Manifiesto":"Landing_Manifiesto__W1BHv","open":"Landing_open__1LOwd"};